// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import { post } from './CoreService';
import websocketsStore from './websocketsStore';

async function sendFeedback(body, url) {
  const FeedbackRating = {
    3: 'POSITIVE',
    2: 'NEUTRAL',
    1: 'NEGATIVE',
  };
  let modifiedBody = body;
  modifiedBody.feedback = FeedbackRating[body.feedback];

  try {
    const api_result = await post(url, modifiedBody, {
      contentType: 'application/json',
    });

    if (api_result.status !== 200) {
      const res = await api_result.json();
      throw new Error(res.detail);
    }
    websocketsStore.currentMessage.info.update(() => ({
      type: 'INFO',
      message: 'Das Feedback wurde erfolgreich abgeschickt.',
    }));
  } catch (err) {
    console.log(err);
    websocketsStore.currentMessage.error.update(() => ({
      type: 'ERROR',
      message: 'Das Feedback konnte leider nicht verarbeitet werden.',
    }));
  }
}

export default sendFeedback;
